/** Parse a positive integer from a number input, or return empty while the field is cleared. */
export function parseOptionalPositiveInt(raw: string): number | "" {
  if (raw === "") return "";
  const parsed = parseInt(raw, 10);
  return Number.isFinite(parsed) ? parsed : "";
}

/** Stop scroll-wheel from incrementing/decrementing a focused number input. */
export function preventNumberInputWheelChange(event: React.WheelEvent<HTMLInputElement>): void {
  event.preventDefault();
}

/** Shared inputProps for number fields inside scrollable forms/dialogs. */
export const numberInputProps = {
  onWheel: preventNumberInputWheelChange,
};

/** Parse a non-negative fee amount; null means the field was cleared. */
export function parseOptionalNonNegativeFloat(raw: string): number | null {
  const trimmed = raw.trim();
  if (trimmed === "" || trimmed === ".") return null;
  const parsed = parseFloat(trimmed);
  return Number.isFinite(parsed) && parsed >= 0 ? parsed : null;
}

/** Parse a positive integer for presentation config fields; ignore invalid partial input. */
export function parsePresentationNumber(raw: string): number | null {
  if (raw === "") return null;
  const parsed = parseInt(raw, 10);
  return Number.isFinite(parsed) ? parsed : null;
}
